import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);

import authenticationModule from "./authentication/index";
import vehiclesModule from "./settings/vehicles";
import routeSettingsModule from "./settings/routes";
import organizationHierarchyModule from "./settings/organizationHierarchy";
import usersAndGroupsModule from "./settings/usersAndGroups";
import paymentAndCollectionModule from "./settings/PaymentAndCollection";
import bookingModule from "./settings/bookings";
import consolidationModule from "./settings/consolidation";
import newBookingModule from "./settings/newBooking"


import VuexPersist from "vuex-persist";

const vuexLocal = new VuexPersist({
  key: "muleex",
  storage: window.localStorage,
  reducer: (state) => ({
    booking: state.bookingModule,
    newBooking: state.newBookingModule,
    authentication: state.authentication,
    consolidation: state.consolidationModule,
  }),
});

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    authentication: authenticationModule,
    vehiclesModule,
    routeSettingsModule,
    organizationHierarchyModule,
    paymentAndCollectionModule,
    usersAndGroupsModule,
    bookingModule,
    newBookingModule,
    consolidationModule
  },
  plugins: [vuexLocal.plugin],

  strict: process.env.NODE_ENV !== "production",
});
